import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeSavedLocation } from "../store/slices/uiPreferencesSlice";
import { AppDispatch } from "../store";

interface LocationInitializerProps {
  children: React.ReactNode;
}

const LocationInitializer: React.FC<LocationInitializerProps> = ({
  children,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Initialize saved location when the app starts
    dispatch(initializeSavedLocation());
  }, [dispatch]);

  return <>{children}</>;
};

export default LocationInitializer;
